module.exports = "<aside id=\"<%= id %>\" class=\"creative creative--revealer\">\n    <a class=\"creative__cta\" href=\"<%=clickMacro%><%=link%>\" target=\"_blank\">\n        <div class=\"creative__background\" style=\"background-image: url('<%=backgroundImage%>')\"></div>\n        <img class=\"creative__button creative__button--<%=buttonVPos%> creative__button--<%=buttonHPos%>\" src=\"<%=button%>\" alt>\n    </a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./static/src/javascripts/projects/commercial/views/creatives/revealer.html
// module id = 587
// module chunks = 1